<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19.07 22.334a1.73 1.73 0 01-.895-.256 1.754 1.754 0 01-.653-.715l-4.765-9.53H7a1 1 0 010-2h5.92a1.735 1.735 0 011.558.97l4.765 9.53H25a1 1 0 010 2h-5.93zm5.93-10.5h-6.75a1 1 0 010-2H25a1 1 0 010 2z"/></svg>
</template>

<script>
export default {
  name: 'webSystemOption'
}
</script>
